import BrandDetailContainer from './BrandDetailContainer';
export default BrandDetailContainer;
